<template lang="pug">
#document-view(v-if="document")
  .banner.bg-cover.hidden-xs
  second-menu(:tabs="tabs", :synctab.sync="selectedTab")
  #news-view-content
    .banner.bg-cover.visible-xs
    section.pt0
      .container
        table.table.row
          thead.hidden-xs
            tr
              th {{'DATE' | wordDict}}
              th {{'TITLE' | wordDict}}

          tbody
            tr(v-for="row in documentlist")
              td.date.hidden-xs {{row.date | moment 'D MMMM YYYY'}}
              td
                div
                  a.title(v-if="row.doc_file", :href="row.doc_file.url", :download="row.doc_file.filename", target="_blank")
                    p {{row.title | multilang}}
                  p(v-else) {{row.title | multilang}}
                div.visible-xs.date {{row.date | moment 'DD/MM/YYYY'}}
</template>

<script>
import router from './../../router'
import axios from 'axios'
import SecondMenu from '../second-menu.vue'

const tabs = [
  {
    title: window.wordDict.DOCUMENT_LATEST,
    id: 'Latest Update',
  }, {
    title: window.wordDict.DOCUMENT_PB,
    id: 'Project Briefs',
  }, {
    title: window.wordDict.DOCUMENT_FIN,
    id: 'Financials',
  }, {
    title: window.wordDict.DOCUMENT_NEWS,
    id: 'News',
  }, {
    title: window.wordDict.DOCUMENT_OTHERS,
    id: 'Others',
  }
]

export default {
  data () {
    return {
      tabs,
      selectedTab: tabs[0].id,
      document: null
    }
  },
  computed: {
    documentlist() {
      let tab = this.selectedTab
      return this.document.filter((doc) => doc.category == tab)
    }
  },
  created () {
    axios.get('/api/document', {
      params: {
        hits: 1000
      }
    })
    .then((response) => {
      if (_.has(response.data, 'results')) {
        let results = response.data.results
        this.document = results
      }
    })
    .catch(function (error) {
      router.go('/login')
    })
  },
  ready () {
    this.selectedTab = tabs[0].id
  },
  watch: {},
  methods: {},
  components: {
    SecondMenu
  }
}
</script>

<style lang="scss" scoped>
@import "global";

#document-view {
  td {
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: #efefef;
    @media (max-width:$grid-float-breakpoint-max) {
      padding: 16px 16px 15px 16px;
    }
    .title p {
      color: #0b4a7e;
      @media (max-width:$grid-float-breakpoint-max) {
        margin-bottom: 4px;
      }
    }
  }
  @media (max-width:$grid-float-breakpoint-max) {
    .container {
      margin-top: 0px;
    }
  }
}

.banner {
  background-image: url('./images/img-latest.jpg');
  &.visible-xs {
    padding-bottom: 52%;
    background-size: cover;
    background-position: center;
  }
  &.hidden-xs {
    padding-bottom: 32%;
    background-size: 100%;
    background-position: 0 80px;
    background-attachment: fixed;
    margin-bottom: 40px;
  }
  @media (max-width:$grid-float-breakpoint-max) {
    margin-top: $responsive-mdl-selector-height;
    .banner {
      padding-bottom: 52%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// document-page.vue?29ccd0bc